export const API_BASE_URL = process.env['REACT_APP_BASE_URL'] || '';
export const API_V2_BASE_URL = process.env['REACT_APP_V2_BASE_URL'] || '';

export const PASSWORD_REGEX =
	/^(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/;

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
